import areaListData from '@/data/area'
import { HttpRequest } from 'utils/'

/**
 * @desc 函数防抖
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param immediate true 表立即执行，false 表非立即执行
 */
export function debounce (func, wait, immediate = false) {
    let timeout;
    return function () {
      let context = this;
      let args = arguments;
  
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(() => {
          timeout = null;
        }, wait)
        if (callNow) func.apply(context, args)
      } else {
        timeout = setTimeout(function () {
          func.apply(context, args)
        }, wait);
      }
    }
  }
  
  /**
   * @description 凭name得到所对应的code码
   * @param name 地区name
   * @param type  省 ？ 市 ？ 区 1 为省 2 为市 3为区县 默认省
   * @return 地区code
   */
  export function getAreaCode (name,type = 1) {
    const list = areaListData[type === 1 ? 'province_list' : type === 2 ? 'city_list' : 'county_list']
    const result = Object.keys(list).find(key=>list[key] === name)
    return result
  } 

  /**
   * @description 统计方法
   * @param item 数据项
   */
  export function statisticalHandle (item) {
    let url = item.api_url.split('8000')[1] ? item.api_url.split('8000')[1] : item.api_url
    HttpRequest({url})
  }

  /**
   * @description 获取当天时间
   * @param item 数据项
   */
  export function getDate () {
    let date = new Date()
    const newDate = date.getFullYear() + '-' 
                  + (date.getMonth() < 9 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-' 
                  + (date.getDate() < 10 ? ('0' + date.getDate()) : (date.getDate()))
    console.log(newDate)
    return newDate;
  }

/**
 * 产生随机整数，包含下限值，但不包括上限值
 * @param {Number} lower 下限
 * @param {Number} upper 上限
 * @return {Number} 返回在下限到上限之间的一个随机整数
 */
export function random(lower, upper) {
	return Math.floor(Math.random() * (upper - lower)) + lower;
}
